export default __webpack_public_path__ + "static/Resilience-cb2bc3a48ee6b433ed5f65695892d175.svg";